/**
 * Generated by orval v8.21.0 🍺
 * Do not edit manually.
 * FINRA Market Data API
 * Market data aggregation backend for FINRA data sources
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DetailNotFoundErrorResponse,
  GetMutualFundChartDataParams,
  HTTPValidationError,
  InternalErrorResponse,
  InvalidRequestErrorResponse,
  MutualFundChartData,
  MutualFundDetail,
  UpstreamAuthenticationFailedErrorResponse,
  UpstreamBadGatewayErrorResponse,
  UpstreamNotFoundErrorResponse,
  UpstreamUnavailableErrorResponse,
  WrongInvestmentTypeErrorResponse
} from '../fINRAMarketDataAPI.schemas.ts';

import { apiFetch } from '../../../lib/api-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type getMutualFundDetailResponse200 = {
  data: MutualFundDetail
  status: 200
}

export type getMutualFundDetailResponse404 = {
  data: DetailNotFoundErrorResponse | WrongInvestmentTypeErrorResponse | UpstreamNotFoundErrorResponse
  status: 404
}

export type getMutualFundDetailResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getMutualFundDetailResponse500 = {
  data: UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse
  status: 500
}

export type getMutualFundDetailResponse502 = {
  data: UpstreamBadGatewayErrorResponse
  status: 502
}

export type getMutualFundDetailResponse503 = {
  data: UpstreamUnavailableErrorResponse
  status: 503
}

export type getMutualFundDetailResponseSuccess = (getMutualFundDetailResponse200) & {
  headers: Headers;
};
export type getMutualFundDetailResponseError = (getMutualFundDetailResponse404 | getMutualFundDetailResponse422 | getMutualFundDetailResponse500 | getMutualFundDetailResponse502 | getMutualFundDetailResponse503) & {
  headers: Headers;
};

export type getMutualFundDetailResponse = (getMutualFundDetailResponseSuccess | getMutualFundDetailResponseError)

export const getGetMutualFundDetailUrl = (symbol: string,) => {




  return `/api/v1/mutual_fund/${symbol}/detail`
}

/**
 * Get the full mutual fund detail page response for a given symbol.
 *
 * Aggregates data from Morningstar Investment Details API
 * into a structured response for the mutual fund detail page.
 *
 * Args:
 *     symbol: The mutual fund trading symbol (e.g., "VFIAX", "SWPPX")
 *     morningstar: Injected MorningstarClient instance
 *     edgar: Injected EDGARClient instance
 *
 * Returns:
 *     MutualFundDetail response model, with sections
 *     Chart data is served by a separate lazy-loaded endpoint.
 *     CMS content is not included in this response.
 *
 * Raises:
 *     404: Symbol not found in Morningstar
 *     500: Morningstar API error or authentication failure
 * @summary Get Mutual Fund Detail
 */
export const getMutualFundDetail = async (symbol: string, options?: RequestInit): Promise<getMutualFundDetailResponse> => {

  return apiFetch<getMutualFundDetailResponse>(getGetMutualFundDetailUrl(symbol),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMutualFundDetailQueryKey = (symbol: string,) => {
    return [
    `/api/v1/mutual_fund/${symbol}/detail`
    ] as const;
    }


export const getGetMutualFundDetailQueryOptions = <TData = Awaited<ReturnType<typeof getMutualFundDetail>>, TError = DetailNotFoundErrorResponse | WrongInvestmentTypeErrorResponse | UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(symbol: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMutualFundDetail>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMutualFundDetailQueryKey(symbol);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMutualFundDetail>>> = ({ signal }) => getMutualFundDetail(symbol, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: symbol !== null && symbol !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMutualFundDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMutualFundDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getMutualFundDetail>>>
export type GetMutualFundDetailQueryError = DetailNotFoundErrorResponse | WrongInvestmentTypeErrorResponse | UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse


export function useGetMutualFundDetail<TData = Awaited<ReturnType<typeof getMutualFundDetail>>, TError = DetailNotFoundErrorResponse | WrongInvestmentTypeErrorResponse | UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 symbol: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMutualFundDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMutualFundDetail>>,
          TError,
          Awaited<ReturnType<typeof getMutualFundDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMutualFundDetail<TData = Awaited<ReturnType<typeof getMutualFundDetail>>, TError = DetailNotFoundErrorResponse | WrongInvestmentTypeErrorResponse | UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 symbol: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMutualFundDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMutualFundDetail>>,
          TError,
          Awaited<ReturnType<typeof getMutualFundDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMutualFundDetail<TData = Awaited<ReturnType<typeof getMutualFundDetail>>, TError = DetailNotFoundErrorResponse | WrongInvestmentTypeErrorResponse | UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 symbol: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMutualFundDetail>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Mutual Fund Detail
 */

export function useGetMutualFundDetail<TData = Awaited<ReturnType<typeof getMutualFundDetail>>, TError = DetailNotFoundErrorResponse | WrongInvestmentTypeErrorResponse | UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 symbol: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMutualFundDetail>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMutualFundDetailQueryOptions(symbol,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getMutualFundChartDataResponse200 = {
  data: MutualFundChartData
  status: 200
}

export type getMutualFundChartDataResponse400 = {
  data: InvalidRequestErrorResponse
  status: 400
}

export type getMutualFundChartDataResponse404 = {
  data: UpstreamNotFoundErrorResponse
  status: 404
}

export type getMutualFundChartDataResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getMutualFundChartDataResponse500 = {
  data: UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse
  status: 500
}

export type getMutualFundChartDataResponse502 = {
  data: UpstreamBadGatewayErrorResponse
  status: 502
}

export type getMutualFundChartDataResponse503 = {
  data: UpstreamUnavailableErrorResponse
  status: 503
}

export type getMutualFundChartDataResponseSuccess = (getMutualFundChartDataResponse200) & {
  headers: Headers;
};
export type getMutualFundChartDataResponseError = (getMutualFundChartDataResponse400 | getMutualFundChartDataResponse404 | getMutualFundChartDataResponse422 | getMutualFundChartDataResponse500 | getMutualFundChartDataResponse502 | getMutualFundChartDataResponse503) & {
  headers: Headers;
};

export type getMutualFundChartDataResponse = (getMutualFundChartDataResponseSuccess | getMutualFundChartDataResponseError)

export const getGetMutualFundChartDataUrl = (symbol: string,
    params: GetMutualFundChartDataParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/mutual_fund/${symbol}/chart?${stringifiedParams}` : `/api/v1/mutual_fund/${symbol}/chart`
}

/**
 * Get the mutual fund chart data for a given symbol and date range.
 * Uses Time Series API from Morningstar to fetch historical price data.
 *
 * Args:
 *     symbol: The mutual fund trading symbol (e.g., "VFIAX", "SWPPX")
 *     start_date: Start of date range in DD-MM-YYYY format (e.g., "01-01-2025")
 *     end_date: End of date range in DD-MM-YYYY format (e.g., "31-12-2025")
 *     morningstar: Injected MorningstarClient instance
 *
 * Returns:
 *     MutualFundChartData wrapping the Morningstar time-series response
 *
 * Raises:
 *     400: Date range exceeds the 1 year maximum allowed by the Time Series API
 *     404: Symbol not found in Morningstar
 *     500: Morningstar API error or authentication failure
 * @summary Get Mutual Fund Chart
 */
export const getMutualFundChartData = async (symbol: string,
    params: GetMutualFundChartDataParams, options?: RequestInit): Promise<getMutualFundChartDataResponse> => {

  return apiFetch<getMutualFundChartDataResponse>(getGetMutualFundChartDataUrl(symbol,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMutualFundChartDataQueryKey = (symbol: string,
    params?: GetMutualFundChartDataParams,) => {
    return [
    `/api/v1/mutual_fund/${symbol}/chart`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMutualFundChartDataQueryOptions = <TData = Awaited<ReturnType<typeof getMutualFundChartData>>, TError = InvalidRequestErrorResponse | UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(symbol: string,
    params: GetMutualFundChartDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMutualFundChartData>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMutualFundChartDataQueryKey(symbol,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMutualFundChartData>>> = ({ signal }) => getMutualFundChartData(symbol,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: symbol !== null && symbol !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMutualFundChartData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMutualFundChartDataQueryResult = NonNullable<Awaited<ReturnType<typeof getMutualFundChartData>>>
export type GetMutualFundChartDataQueryError = InvalidRequestErrorResponse | UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse


export function useGetMutualFundChartData<TData = Awaited<ReturnType<typeof getMutualFundChartData>>, TError = InvalidRequestErrorResponse | UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 symbol: string,
    params: GetMutualFundChartDataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMutualFundChartData>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMutualFundChartData>>,
          TError,
          Awaited<ReturnType<typeof getMutualFundChartData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMutualFundChartData<TData = Awaited<ReturnType<typeof getMutualFundChartData>>, TError = InvalidRequestErrorResponse | UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 symbol: string,
    params: GetMutualFundChartDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMutualFundChartData>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMutualFundChartData>>,
          TError,
          Awaited<ReturnType<typeof getMutualFundChartData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMutualFundChartData<TData = Awaited<ReturnType<typeof getMutualFundChartData>>, TError = InvalidRequestErrorResponse | UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 symbol: string,
    params: GetMutualFundChartDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMutualFundChartData>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Mutual Fund Chart
 */

export function useGetMutualFundChartData<TData = Awaited<ReturnType<typeof getMutualFundChartData>>, TError = InvalidRequestErrorResponse | UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 symbol: string,
    params: GetMutualFundChartDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMutualFundChartData>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMutualFundChartDataQueryOptions(symbol,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






